import { T } from "../tokens";

const PIPELINE_URL = "https://footballpipeline.zeabur.app";

// The three tiers here must stay in sync with client_config.py's
// TIER_DEFINITIONS on the backend — same keys, same feature lists.
const TIERS = [
  {key:"MACRO",       label:"Tactical overview",  time:"~3 min GPU",
   desc:"Formations · Heatmaps · Defensive lines",
   color:"#1baf7a", features:["Team heatmaps","Formation detection","Defensive line","Press map"]},
  {key:"PERFORMANCE", label:"Performance analysis",time:"~10 min GPU",
   desc:"Speed · Distance · Per-player CSV",
   color:T.accent, features:["Everything in Tactical","Per-player CSV","Speed & distance","Re-ID tracking"]},
  {key:"FULL",        label:"Full analysis",       time:"~35 min CPU",
   desc:"Everything + Pose estimation",
   color:"#7F77DD", features:["Everything in Performance","Pose estimation","Reliability report","Pose CSV export"]},
];

export default function UploadPanel({
  selectedMode, setSelectedMode,
  uploadFile, setUploadFile,
  uploadStatus, jobId, jobProgress,
  handleVideoUpload,
}) {
  return (
    <div style={{background:T.panel,borderBottom:`1px solid ${T.border}`,padding:"16px 20px"}}>
      {/* Tier selector */}
      <div style={{display:"grid",gridTemplateColumns:"1fr 1fr 1fr",gap:10,marginBottom:14}}>
        {TIERS.map(m=>(
          <div key={m.key} onClick={()=>setSelectedMode(m.key)} style={{
            border:`2px solid ${selectedMode===m.key?m.color:T.border}`,
            borderRadius:10,padding:"12px 14px",cursor:"pointer",
            background:selectedMode===m.key?`${m.color}11`:T.surface,
            transition:"all 0.15s"
          }}>
            <div style={{fontWeight:700,fontSize:12,color:selectedMode===m.key?m.color:T.textPri,marginBottom:3}}>{m.label}</div>
            <div style={{fontSize:10,color:T.textSec,marginBottom:8}}>{m.desc}</div>
            <div style={{fontSize:9,padding:"2px 6px",borderRadius:4,display:"inline-block",
              background:selectedMode===m.key?`${m.color}22`:T.border,
              color:selectedMode===m.key?m.color:T.textDim,marginBottom:8}}>{m.time}</div>
            <div style={{display:"flex",flexDirection:"column",gap:2}}>
              {m.features.map(f=>(
                <div key={f} style={{fontSize:9,color:T.textSec,display:"flex",alignItems:"center",gap:4}}>
                  <span style={{color:m.color,fontSize:8}}>✓</span>{f}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>

      {/* File upload */}
      <div style={{display:"flex",gap:10,alignItems:"center"}}>
        <label style={{flex:1,background:T.surface,border:`1px dashed ${T.border}`,borderRadius:8,
          padding:"10px 14px",cursor:"pointer",textAlign:"center",
          color:uploadFile?T.textPri:T.textDim,fontSize:11,fontFamily:"inherit"}}>
          {uploadFile ? `📹 ${uploadFile.name}` : "📹 Click to select match video (.mp4)"}
          <input type="file" accept="video/mp4,video/*" onChange={e=>setUploadFile(e.target.files[0])}
            style={{display:"none"}}/>
        </label>
        <button onClick={handleVideoUpload}
          disabled={!uploadFile||uploadStatus==="uploading"||uploadStatus==="processing"}
          style={{background:uploadFile?T.accent:"#1E2733",border:"none",
            borderRadius:8,color:"#fff",padding:"10px 20px",cursor:uploadFile?"pointer":"not-allowed",
            fontSize:12,fontWeight:700,fontFamily:"inherit",opacity:uploadFile?1:0.5,
            whiteSpace:"nowrap"}}>
          {uploadStatus==="uploading"?"Uploading...":
           uploadStatus==="processing"?"Processing...":
           uploadStatus==="done"?"✅ Done — reload":"Analyze Match ↗"}
        </button>
      </div>

      {/* Status */}
      {uploadStatus==="processing" && (
        <div style={{marginTop:10,fontSize:11,color:T.textSec,display:"flex",alignItems:"center",gap:8}}>
          <div style={{width:8,height:8,borderRadius:"50%",background:T.accent,
            animation:"pulse 1.5s infinite"}}/>
          Processing with {selectedMode} mode · Job: {jobId?.slice(0,8)}...
          {jobProgress?.status && ` · ${jobProgress.status}`}
        </div>
      )}
      {uploadStatus==="done" && (
        <div style={{marginTop:10,display:"flex",gap:8,flexWrap:"wrap"}}>
          {jobId && ["tracking.csv","heatmap.png",selectedMode==="FULL"?"pose.csv":null,
                     "output.mp4"].filter(Boolean).map(f=>(
            <a key={f} href={`/download/${jobId}/${f}`} download style={{
              fontSize:10,padding:"4px 10px",borderRadius:5,textDecoration:"none",
              background:`${T.accent}22`,color:T.accent,border:`1px solid ${T.accent}44`}}>
              ↓ {f}
            </a>
          ))}
        </div>
      )}
      {uploadStatus==="error" && (
        <div style={{marginTop:10,fontSize:11,color:"#F59E0B"}}>
          ⚠️ Processing failed. Check server logs or try again.
        </div>
      )}
    </div>
  );
}
